/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Asi_Statement_TitleInputs */

const en_home_quotes_asi_statement_title = /** @type {(inputs: Home_Quotes_Asi_Statement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`110,000+ signatories including AI researchers, political, faith and industry leaders, artists and media celebrities`)
};

/**
* | output |
* | --- |
* | "110,000+ signatories including AI researchers, political, faith and industry leaders, artists and media celebrities" |
*
* @param {Home_Quotes_Asi_Statement_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_asi_statement_title = /** @type {((inputs?: Home_Quotes_Asi_Statement_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Asi_Statement_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_asi_statement_title(inputs)
});